<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    {{this.Title}}
</h1>
<div *ngIf="!this.ExportOnly">
    <div *ngIf="this.mode == 'import' && !this.JobInitiated && !this.importFile" class="switchmode">
        <button (click)="this.switchToExport()">Switch to Export</button>
    </div>
    <div *ngIf="this.mode == 'export' && !this.JobInitiated" class="switchmode">
        <button (click)="this.switchToImport()">Switch to Import</button>
    </div>
</div>

<div *ngIf="this.mode == 'import'" class="dropzone">
    <label for="fileDropRef">Select an Excel file for data import.</label><br /><br />
    <input type="file" class="inputfile" accept=".xls, .xlsx" #fileDropRef id="fileDropRef" (change)="this.importFileSelected($event)" />
</div>

<form>
    <span *ngIf="this.mode == 'export'" class="form-names-span" style="margin-top: 17px;">Choose forms:</span>
    <div *ngIf="this.mode == 'export'" class="form-names-div" style="{{this.FormNamesDivInlineStyles}}">
        <mat-selection-list [(ngModel)]="this.SelectedFormNames"
                            (ngModelChange)="this.formNamesSelectionChanged()"
                            class="form-names-selection-list"
                            style="{{this.FormNamesListInlineStyles}}"
                            name="naButNameIsRequired">
            <mat-list-option *ngFor="let formName of this.SiteFormNames"
                             checkboxPosition="before"
                             [value]="formName">
                {{formName}}
                <span *ngIf="formName.length > 31" class="warning">
                    Long name will be shortened
                    <mat-icon role="img" tabindex="0"
                              class="mat-icon"
                              aria-hidden="true" title="Template name will be shortened to 31 characters to form valid Excel sheet name" data-mat-icon-type="font"> info </mat-icon>
                </span>
            </mat-list-option>
        </mat-selection-list>
    </div>

    <div mat-dialog-content>
        <p class="{{this.ExportDescriptionCssClass}}">{{this.ExportDescription}}</p>
    </div>

    <div class="execution-time-div">
        <span>Execution Time:</span>
        <span class="{{this.JobTimeElapsedCssClass}}">{{this.JobTimeElapsed}}</span>
    </div>

    <div *ngIf="this.mode == 'export'" class="execution-status-div">
        <span>Execution Status: </span>
        <span>{{this.ExportStatus}}</span>
    </div>

    <div class="execution-summary-div">
        <p [ngClass]="this.JobErrorOccurred ? 'execution-summary-p execution-summary-with-error-p' : 'execution-summary-p execution-summary-without-error-p'"
           data-placeholder="Details will display here ...">
            <span *ngFor="let textPart of SplitPipe(ExecutionSummaryText)">{{textPart}}<br></span>
        </p>
    </div>
    <mat-icon-button *ngIf="ExecutionSummaryText.length > 0" [cdkCopyToClipboard]="ExecutionSummaryText" title="Copy to Clipboard">
        <mat-icon id="copybutton">content_copy</mat-icon>
    </mat-icon-button>

    <br />

    <div mat-dialog-actions id="actionsdiv">
        <button *ngIf="this.mode == 'import'"
                mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="this.importStarted || !this.importFile"
                (click)="this.startFormDataImport($event)">
            {{this.startMessage}}
        </button>
        <button *ngIf="this.mode == 'export' && ! this.JobCompleted"
                mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="this.NoFormNamesSelected || this.JobInitiated"
                (click)="this.startFormDataExport()">
            {{this.startMessage}}
        </button>
        <button mat-flat-button
                type="submit"
                color="accent"
                [disabled]="!this.JobInitiated"
                style="margin-left: 10px;"
                (click)="this.dismissDialogue()">
            Dismiss
        </button>

        <ng-container *ngIf="this.mode == 'export'">
            <a *ngIf="this.ExportedDataUrl != null"
               href="{{this.ExportedDataUrl}}"
               target="_blank"
               class="download-a">Download</a>
            <span *ngIf="this.ExportedDataUrl == null"
                  class="download-span">Download</span>
        </ng-container>

        <button mat-stroked-button
                [disabled]="this.JobInitiated"
                color="basic"
                (click)="this.cancelDialogue()"
                style="margin-left: 10px;">
            {{cancelButton}}
        </button>
    </div>
</form>
